/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, Section, Container, CrossLink } from '@tishman/components';
import React, { useMemo } from 'react';
import invariant from 'invariant';

import { usePageData } from '../utils';

import type { ComponentPropsWithoutRef } from 'react';

const RinkCrossLinkBlock = (
  props: ComponentPropsWithoutRef<typeof Section>,
): React.JSX.Element => {
  const { events } = usePageData<Queries.AttractionRinkQuery>();

  const crossLinks = events?.crossLinks;

  invariant(crossLinks, 'Rink crossLinks data is required!');

  const rinkCrossLinkProps = useMemo(
    () =>
      crossLinks.map((crossLink) => ({
        gatsbyImageData: crossLink?.image?.asset?.gatsbyImageData,
        alt: crossLink?.image?.alt || '',
        caption: crossLink?.image?.caption || '',
        title: crossLink?.title || '',
        link: {
          label: crossLink?.link?.caption || '',
          url: crossLink?.link?.url || '',
        },
      })),
    [crossLinks],
  );

  return (
    rinkCrossLinkProps && (
      <Section data-section="RinkCrossLink" {...props}>
        <Container sx={{ py: [3, 4, 6] }}>
          <Flex
            sx={{
              justifyContent: 'space-between',
              flexDirection: ['column', null, 'row'],
            }}
          >
            {rinkCrossLinkProps.map((crossLink) => (
              <CrossLink
                key={crossLink.title}
                sx={{ fontFamily: 'headingSecondary' }}
                {...crossLink}
              />
            ))}
          </Flex>
        </Container>
      </Section>
    )
  );
};

export default RinkCrossLinkBlock;
